<template>
  <div>
    <CCard>
      <CCardHeader>
        <span class="font-weight-bold">
          <CIcon name="cilShareBoxed" />
          DS Xuất Kho
        </span>
        <div class="d-inline-block float-right align-right">
          <CButton
            color="info"
            size="sm"
            class="mr-2"
            @click.prevent="
              (e) => {
                showFilter = !showFilter;
              }
            "
          >
            <CIcon v-if="showFilter" name="cil-chevron-top" />
            <CIcon v-else name="cil-chevron-bottom" />
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <filter-box v-if="showFilter" @done="(e) => doFilter(e)" />
        <odata-table
          ref="lstInventoryExport"
          url="odata/InventoryExport"
          tableClass="table-striped"
          :filter="filter"
          :expand="
            `Warehouse($select=Name),` +
              `InventoryExportItems($top=1;$count=true;$select=ProductName,QtyActual;$filter=Status eq ${this.$const.STATUS.Active})`
          "
          sortBy="CreatedAt desc"
          :pageSize="pageSize"
          :colSetting="{
            Action: {
              display: '#',
              sortable: false,
              style: 'min-width: 50px;',
            },
            Warehouse: {
              field: 'Warehouse/Name',
              display: 'Kho',
              sortable: false,
              style: 'min-width: 100px',
            },

            ExportDate: {
              field: 'ExportDate',
              display: 'Ngày xuất',
              sortable: true,
              style: 'min-width: 120px',
            },
            WarehouseKeeper: {
              field: 'WarehouseKeeper',
              display: 'Thủ kho',
              sortable: true,
              style: 'min-width: 120px',
            },
            Status: {
              field: 'Status',
              display: 'Trạng thái',
              sortable: true,
              style: 'min-width: 100px',
            },
            ExportDetail: {
              field: 'ExportDetail',
              display: 'Chi tiết',
              sortable: false,
              style: 'min-width: 200px',
            },
          }"
        >
          <template v-slot:tbody="{ rows }">
            <tr v-if="$refs.lstInventoryExport.loading">
              <td colspan="100%">
                <div class="spinner-border m-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
            </tr>
            <tr v-else v-for="(row, i) in rows" :key="`tr-${i}`">
              <td>
                <div class="text-nowrap">
                  {{ i + 1 + ($refs.lstInventoryExport.page - 1) * pageSize }}.
                </div>
              </td>
              <td>
                <span v-if="row.Warehouse">
                  {{ row.Warehouse ? row.Warehouse.Name : "" }}
                </span>
              </td>

              <td>
                <a
                  href="javascript:"
                  class="text-primary"
                  :title="`Chi tiết Nhập Kho`"
                  @click="
                    (e) => {
                      $router
                        .push({
                          name: 'InventoryExport',
                          query: { id: row.Id },
                        })
                        .catch(() => {});
                    }
                  "
                >
                  {{ $moment(row.ExportDate).format("DD/MM/YYYY HH:mm") }}
                </a>
              </td>
              <td>
                <span>
                  {{ row.WarehouseKeeper }}
                </span>
              </td>
              <td>
                <CBadge :color="getBadge(row.Status)">
                  {{ $const.EXPORT_STATUS_TEXT[row.Status] }}
                </CBadge>
              </td>
              <td class="text-truncate" style="max-width:200px;">
                <span
                  :title="
                    renderDetails(
                      row.InventoryExportItems,
                      row['InventoryExportItems@odata.count']
                    )
                  "
                >
                  {{
                    renderDetails(
                      row.InventoryExportItems,
                      row["InventoryExportItems@odata.count"]
                    )
                  }}
                </span>
              </td>
            </tr>
          </template>
        </odata-table>
      </CCardBody>
    </CCard>

    <detail
      :showing.sync="showing"
      :exportId="routeExportId"
      @reload="$refs.lstInventoryExport.loadData()"
    />
  </div>
</template>

<script>
import odataTable from "@/components/odataTable.vue";
import detail from "./Detail.vue";
import filterBox from "./Filter.vue";

export default {
  name: "InventoryExport",
  components: {
    odataTable,
    detail,
    filterBox,
  },
  data() {
    return {
      pageSize: 20,
      showing: false,
      showFilter: false,
      filters: null,
    };
  },
  mounted() {
    if (this.routeExportId) {
      this.showing = true;
    }
  },
  computed: {
    filter() {
      let filters = [];

      if (this.filters && this.filters.length) {
        filters = [...this.filters];
      }

      return filters.join(" and ");
    },

    routeExportId() {
      let exportId = this.$route.query.id;
      return !isNaN(exportId) ? exportId : 0;
    },
  },
  watch: {
    routeExportId(val) {
      this.showing = !!val;
    },
  },

  methods: {
    doFilter(e) {
      if (JSON.stringify(this.filters) != JSON.stringify(e)) {
        this.filters = e;
      } else {
        this.$refs.lstInventoryExport.loadData();
      }
    },

    renderDetails(exportItems, count) {
      if (exportItems && exportItems.length) {
        let list = [];
        list.push(
          `Xuất ${exportItems[0].QtyActual} ${exportItems[0].ProductName}`
        );
        count > 1 && list.push(`${count - 1} sản phẩm khác`);
        return list.join(" và ");
      }
      return null;
    },

    getBadge(status) {
      switch (status) {
        case this.$const.EXPORT_STATUS.Approved:
          return "success";
        case this.$const.EXPORT_STATUS.OnGoing:
          return "info";
        case this.$const.EXPORT_STATUS.Waiting:
          return "warning";
        case this.$const.EXPORT_STATUS.Cancelled:
          return "secondary";
        case this.$const.EXPORT_STATUS.Returned:
          return "danger";
        default:
          "primary";
      }
    },
  },
};
</script>
